import "./App.css";
import "./style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import RoutesPath from "./routes/Routes";

function App() {
  return <RoutesPath />;
}
export default App;
